import React, { createContext, useContext, useRef, useState } from "react";

const DocumentContext = createContext();

export const DocumentInfoProvider = ({ children }) => {

  const [savingData, setSavingData] = useState({
    isSaving: '',
    lastSavedDateTime: "",
    fileSize: 0,
  });
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isExternal, setIsExternal] = useState(false);
  const [isExternalAllow, setIsExternalAllow] = useState(false);
  const [documentInfo, setDocumentInfo] = useState({});
  const [userInfo, setUserInfo] = useState({});
  const [boardData, setBoardData] = useState();
  const [isConflictModalVisible, setIsConflictModalVisible] = useState(false);
  const [serverData, setServerData] = useState(null);
  const isLoadingVersion = useRef(false);
  const [conflictPreviewVerion, setConflictPreviewVerion] = useState(null);
  

  return (
    <DocumentContext.Provider
      value={{
        savingData, setSavingData,
        isReadOnly, setIsReadOnly,
        isExternal, setIsExternal,
        isExternalAllow, setIsExternalAllow,
        documentInfo, setDocumentInfo,
        userInfo, setUserInfo,
        boardData, setBoardData,
        isConflictModalVisible, setIsConflictModalVisible,
        serverData, setServerData,
        isLoadingVersion,
        conflictPreviewVerion, setConflictPreviewVerion
      }}>
      {children}
    </DocumentContext.Provider>
  );
};

export const useDocument = () => {
  return useContext(DocumentContext);
};
